export default __webpack_public_path__ + "static/media/mobile_logo.62b3e917.svg";